import React from 'react';
import {noop} from 'lodash';

import MetricSection from '/component/partial/MetricSection';
import {PlainMetricItem} from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';
import {COACH} from '/enum/competency.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

import {useListItems} from './PersonalPerformanceSection.hook';

interface PersonalPerformanceSectionProps {
  currentUserCompetency: string;
  frontlineQualifyingVolume: string;
  generation0Volume: string;
  totalGenerationVolume: string;
  orderingEntities: number;
  qualifyingPoints: number;
  onShowInfoPopover: (params: {
    heading: string;
    body: string;
    triggerRef?: React.RefObject<any>;
  }) => void;
}

export const PersonalPerformanceSection: React.FC<
  PersonalPerformanceSectionProps
> = ({
  currentUserCompetency = COACH,
  frontlineQualifyingVolume = '',
  generation0Volume = '',
  totalGenerationVolume = '',
  orderingEntities = 0,
  qualifyingPoints = 0,
  onShowInfoPopover = noop,
}) => {
  const {ts} = useTranslation('screen.performance.section.personalPerformance');

  const listItems = useListItems({
    component: PlainMetricItem,
    currentUserCompetency,
    frontlineQualifyingVolume,
    generation0Volume,
    totalGenerationVolume,
    orderingEntities,
    qualifyingPoints,
  });

  return (
    <MetricSection
      analyticsTitle="Personal Performance Metrics"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Personal Performance Metrics Section Information buuton',
      )}
      testID={MetricsSection.metricSectionPersonalPerformanceMetrics}
      title={ts('heading', 'Personal Performance Metrics')}
      listItems={listItems}
      onInfoPress={generateCallback({
        func: onShowInfoPopover,
        params: {
          heading: ts('info.heading', 'Personal Performance Metrics'),
          body: ts(
            'info.body',
            'View FQV (from your personal Clients/Coaches), Generation Zero (Gen 0) volume (from those sponsored by you or a Coach on your team down to the first ED or above), or Total Generation Volume (TGenV) all volume in your organization.',
          ),
        },
      })}
    />
  );
};

export default PersonalPerformanceSection;
